import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { trackOpenContacts, trackShowPhone } from './tracking';
import { getGaLabel } from '../../selectors/newbuilding';
import { TShowPhoneAction } from '../../types/analytics/call';
import { CallButton } from '../CallButton';

export interface IHeaderCallProps {
  placeType?: string;
  eventAction: TShowPhoneAction;
}

export const HeaderCall = ({ placeType = 'blockFicheringStickyHeader', eventAction }: IHeaderCallProps) => {
  const gaLabel = useSelector(getGaLabel);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, eventAction);
  }, [gaLabel, eventAction]);

  const onOpenContactsClick = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  return (
    <CallButton
      placeType={placeType}
      onOpenContactsClick={onOpenContactsClick}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'XS' as const }}
      showPhoneStyles={{ size: 'XS' as const, beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" /> }}
    />
  );
};

HeaderCall.displayName = 'GalleryCall';
